import * as React from "react";
import { SVGProps } from "react";
export const MultiChevronDownUpIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <mask
            id="mask0_32817_8366"
            style={{
                maskType: "alpha",
            }}
            maskUnits="userSpaceOnUse"
            x={0}
            y={0}
            width={20}
            height={20}
        >
            <rect width={20} height={20} fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_32817_8366)">
            <path
                d="M10.0001 13.6875L8.20841 15.4791C8.05564 15.6319 7.87855 15.7083 7.67716 15.7083C7.47578 15.7083 7.29869 15.6319 7.14591 15.4791C6.99314 15.3263 6.91675 15.1493 6.91675 14.9479C6.91675 14.7465 6.99314 14.5694 7.14591 14.4166L9.47925 12.0833C9.54869 12.0138 9.62855 11.9618 9.71883 11.927C9.80911 11.8923 9.90286 11.875 10.0001 11.875C10.0973 11.875 10.1911 11.8923 10.2813 11.927C10.3716 11.9618 10.4515 12.0138 10.5209 12.0833L12.8542 14.4166C13.007 14.5694 13.0834 14.743 13.0834 14.9375C13.0834 15.1319 13.007 15.3055 12.8542 15.4583C12.7015 15.6111 12.5244 15.6875 12.323 15.6875C12.1216 15.6875 11.9445 15.6111 11.7917 15.4583L10.0001 13.6875ZM10.0001 6.31246L11.7917 4.52079C11.9445 4.36801 12.1216 4.29163 12.323 4.29163C12.5244 4.29163 12.7015 4.36801 12.8542 4.52079C13.007 4.67357 13.0834 4.85065 13.0834 5.05204C13.0834 5.25343 13.007 5.43051 12.8542 5.58329L10.5209 7.91663C10.4515 7.98607 10.3716 8.03815 10.2813 8.07288C10.1911 8.1076 10.0973 8.12496 10.0001 8.12496C9.90286 8.12496 9.80911 8.1076 9.71883 8.07288C9.62855 8.03815 9.54869 7.98607 9.47925 7.91663L7.14591 5.58329C6.99314 5.43051 6.92022 5.25343 6.92716 5.05204C6.93411 4.85065 7.01397 4.67357 7.16675 4.52079C7.31953 4.36801 7.49661 4.29163 7.698 4.29163C7.89939 4.29163 8.07647 4.36801 8.22925 4.52079L10.0001 6.31246Z"
                fill="currentColor"
            />
        </g>
    </svg>
);
MultiChevronDownUpIcon.displayName = "MultiChevronDownUpIcon";
